//przy opisie pamietac by opisac ze wymagane jest person bezposrednio w scope
angular.module('salesPath2')
  .directive('clientSearchV2',
    function() {
      return {
        restrict: 'E',
        replace: true,
        scope: true,
        templateUrl: function(elem, attrs) {
          if (attrs.drvTemplate) {
            return attrs.drvTemplate;
          } else {
            return 'salesPath2Template/autocompleters/clientSearch/clientSearch.tpl.html';
          }
        }
      };
    }
  );